import { createEffect, createEvent, createStore } from 'effector';

import { TStore } from '../types';

import { TItemsWithPagination, TParams } from '~utils';

export const $catalogCommonStore = createStore<TStore<TItemsWithPagination>>({
  status: 'NONE',
  data: null,
  error: null,
});

export const startCommonRequest = createEvent();
export const removeCommonItems = createEvent();
export const updateCommonDataImperative = createEvent<TItemsWithPagination>();

export const getCatalogCommonFx = createEffect(
  async ({ productId, q, queries, fn, fnWithId }: TParams) => {
    startCommonRequest();
    const response = fnWithId ? await fnWithId(productId!, queries, q) : await fn!(queries, q);
    return response;
  },
);

export const updateCatalogCommonBtnFx = createEffect(
  async ({ productId, q, queries, fn, fnWithId }: TParams) => {
    startCommonRequest();
    const response = fnWithId ? await fnWithId(productId!, queries, q) : await fn!(queries, q);
    return response;
  },
);
